import { render } from "./RoomSelectCard.vue?vue&type=template&id=e4fef7fa&scoped=true&ts=true"
import script from "./RoomSelectCard.vue?vue&type=script&lang=ts"
export * from "./RoomSelectCard.vue?vue&type=script&lang=ts"

import "./RoomSelectCard.vue?vue&type=style&index=0&id=e4fef7fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4fef7fa"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QIcon});
